(function () {
  'use strict';

  var runtimeKey = 'LpHalloweenPackRuntime';

  if (window[runtimeKey]) {
    window[runtimeKey].scan(document);
    return;
  }

  var dayOrder = ['mon', 'tue', 'wed', 'thu', 'fri'];
  var dayNames = {
    mon: 'Snack 1',
    tue: 'Snack 2',
    wed: 'Snack 3',
    thu: 'Snack 4',
    fri: 'Snack 5'
  };
  var instances = new WeakMap();

  function isTrue(value) {
    return value === true || value === 'true';
  }

  function safeInteger(value) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function appendJs(route) {
    if (!route) return route;
    return /\.js(?:\?|$)/.test(route) ? route : route + '.js';
  }

  function storefrontRoot() {
    var root = window.theme && window.theme.routes && window.theme.routes.root;
    if (!root && window.Shopify && window.Shopify.routes) root = window.Shopify.routes.root;
    root = root || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function cartRoute(name) {
    var routes = window.theme && window.theme.routes && window.theme.routes.cart;
    var configured = routes && routes[name];
    var fallbacks = {
      base: 'cart',
      add: 'cart/add',
      update: 'cart/update'
    };
    return configured || storefrontRoot() + fallbacks[name];
  }

  function uniquePackId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'lp-hw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 11);
  }

  function publicCartEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function sectionInstances() {
    var sections = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    return sections && Array.isArray(sections.instances) ? sections.instances : [];
  }

  function updateHeaderCartTriggers(source) {
    [
      '.header__content-mobile [data-header-cart]',
      '.header__content-desktop [data-header-cart]'
    ].forEach(function (selector) {
      var current = document.querySelector(selector);
      var updated = source.querySelector(selector);
      if (current && updated) current.innerHTML = updated.innerHTML;
    });
  }

  async function refreshCornerstoneChrome() {
    var sections = sectionInstances();
    var header = sections.find(function (instance) { return instance && instance.type === 'header'; });
    var quickCart = sections.find(function (instance) { return instance && instance.type === 'quick-cart'; });

    if (header && header.id) {
      try {
        var headerResponse = await fetch(storefrontRoot() + '?section_id=' + encodeURIComponent(header.id), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (headerResponse.ok) {
          var headerHtml = await headerResponse.text();
          var headerDocument = new DOMParser().parseFromString(headerHtml, 'text/html');
          updateHeaderCartTriggers(headerDocument);
        }
      } catch (error) {
        // The verified cart remains authoritative even if this cosmetic refresh fails.
      }
    }

    if (
      quickCart &&
      typeof quickCart.refreshQuickCart === 'function' &&
      typeof quickCart.openQuickCart === 'function'
    ) {
      quickCart.refreshQuickCart();
      quickCart.openQuickCart();
      return true;
    }

    return false;
  }

  class HalloweenPack {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || root.id;
      this.campaignId = root.dataset.campaignId || 'halloween';
      this.shop = root.dataset.shop || (window.Shopify && window.Shopify.shop) || window.location.host;
      this.appstleBundleReference = root.dataset.appstleBundleReference || '';
      this.appstleBundleName = root.dataset.appstleBundleName || '';
      this.appstleBundleType = root.dataset.appstleBundleType || 'CLASSIC_BUILD_A_BOX';
      this.abortController = new AbortController();
      this.days = new Map();
      this.products = new Map();
      this.selected = new Map();
      this.activeDay = 'mon';
      this.activeFilter = 'all';
      this.addingToCart = false;
      this.layoutFrame = 0;
      this.carouselFrame = 0;
      this.drag = null;
      this.justDragged = false;
      this.cartController = null;
      this.mobileQuery = window.matchMedia('(max-width: 959px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.viewport = root.querySelector('[data-lp-hw-viewport]');
      this.track = root.querySelector('[data-lp-hw-track]');
      this.emptyCatalog = root.querySelector('[data-lp-hw-empty]');
      this.previousButton = root.querySelector('[data-lp-hw-prev]');
      this.nextButton = root.querySelector('[data-lp-hw-next]');
      this.progress = root.querySelector('[data-lp-hw-progress]');
      this.progressBar = root.querySelector('[data-lp-hw-progress-bar]');
      this.submitButton = root.querySelector('[data-lp-hw-submit]');
      this.selectionCountElements = Array.from(root.querySelectorAll('[data-lp-hw-selection-count]'));
      this.status = root.querySelector('[data-lp-hw-status]');
      this.cartMessage = root.querySelector('[data-lp-hw-cart-message]');
    }

    init() {
      if (!this.viewport || !this.track || !this.submitButton) return;

      this.collectDays();
      this.collectProducts();
      this.initializeSelection();
      this.bindEvents();
      this.render();
      this.scheduleLayout();
    }

    collectDays() {
      var self = this;
      this.root.querySelectorAll('[data-lp-hw-day]').forEach(function (element) {
        var key = element.dataset.lpHwDay;
        if (!dayOrder.includes(key)) return;
        self.days.set(key, {
          element: element,
          label: element.querySelector('.lp-hw__day-label'),
          media: element.querySelector('[data-lp-hw-day-media]'),
          title: element.querySelector('[data-lp-hw-day-title]'),
          remove: element.querySelector('[data-lp-hw-day-remove]'),
          select: element.querySelector('[data-lp-hw-day-select]')
        });
      });
    }

    productFromCard(card) {
      return {
        element: card,
        productId: card.dataset.productId || '',
        variantId: card.dataset.variantId || '',
        title: card.dataset.productTitle || '',
        url: card.dataset.productUrl || '',
        image: card.dataset.productImage || '',
        price: safeInteger(card.dataset.productPrice),
        money: card.dataset.productMoney || '',
        available: isTrue(card.dataset.productAvailable),
        collections: new Set((card.dataset.productCollections || '').split(',').filter(Boolean))
      };
    }

    collectProducts() {
      var self = this;
      Array.from(this.root.querySelectorAll('[data-lp-hw-product]')).forEach(function (card) {
        var product = self.productFromCard(card);
        if (!product.variantId) {
          card.remove();
          return;
        }

        var existing = self.products.get(product.variantId);
        if (!existing) {
          self.products.set(product.variantId, product);
          return;
        }

        product.collections.forEach(function (handle) { existing.collections.add(handle); });
        existing.element.dataset.productCollections = Array.from(existing.collections).join(',');
        card.remove();
      });
    }

    initializeSelection() {
      var restored = this.restoreSelection();
      var self = this;

      if (!restored) {
        this.days.forEach(function (day, key) {
          var product = self.products.get(day.element.dataset.variantId || '');
          self.selected.set(key, product && product.available ? product : null);
        });
      }

      var firstEmpty = dayOrder.find(function (key) { return !self.selected.get(key); });
      if (!dayOrder.includes(this.activeDay)) this.activeDay = firstEmpty || 'mon';
      this.saveSelection();
    }

    storageKey() {
      return ['lp-hw', 'v3', this.shop, this.campaignId, this.sectionId].join(':');
    }

    restoreSelection() {
      try {
        var raw = window.sessionStorage.getItem(this.storageKey());
        if (!raw) return false;
        var saved = JSON.parse(raw);
        if (!saved || saved.version !== 3 || !saved.selected) return false;

        var self = this;
        dayOrder.forEach(function (key) {
          var variantId = String(saved.selected[key] || '');
          var product = self.products.get(variantId);
          self.selected.set(key, product && product.available ? product : null);
        });
        if (dayOrder.includes(saved.activeDay)) this.activeDay = saved.activeDay;
        return true;
      } catch (error) {
        return false;
      }
    }

    saveSelection() {
      try {
        var selected = {};
        dayOrder.forEach((key) => {
          var product = this.selected.get(key);
          selected[key] = product ? product.variantId : null;
        });
        window.sessionStorage.setItem(this.storageKey(), JSON.stringify({
          version: 3,
          activeDay: this.activeDay,
          selected: selected
        }));
      } catch (error) {
        // Storage is optional; the in-memory state remains fully functional.
      }
    }

    bindEvents() {
      var signal = this.abortController.signal;

      this.root.addEventListener('click', this.onClick.bind(this), { signal: signal });
      this.root.addEventListener('click', this.onCapturedClick.bind(this), { signal: signal, capture: true });
      this.root.addEventListener('shopify:block:select', this.onBlockSelect.bind(this), { signal: signal });
      this.viewport.addEventListener('scroll', this.scheduleCarouselUpdate.bind(this), { signal: signal, passive: true });
      this.viewport.addEventListener('pointerdown', this.onPointerDown.bind(this), { signal: signal });
      this.viewport.addEventListener('pointermove', this.onPointerMove.bind(this), { signal: signal });
      this.viewport.addEventListener('pointerup', this.onPointerUp.bind(this), { signal: signal });
      this.viewport.addEventListener('pointercancel', this.onPointerUp.bind(this), { signal: signal });

      this.resizeObserver = new ResizeObserver(this.scheduleLayout.bind(this));
      this.resizeObserver.observe(this.viewport);
    }

    onCapturedClick(event) {
      if (!this.justDragged) return;
      event.preventDefault();
      event.stopPropagation();
      this.justDragged = false;
    }

    onClick(event) {
      var remove = event.target.closest('[data-lp-hw-day-remove]');
      if (remove && this.root.contains(remove)) {
        event.preventDefault();
        var removeDay = remove.closest('[data-lp-hw-day]');
        this.removeDay(removeDay && removeDay.dataset.lpHwDay);
        return;
      }

      var daySelect = event.target.closest('[data-lp-hw-day-select]');
      if (daySelect && this.root.contains(daySelect)) {
        event.preventDefault();
        var selectedDay = daySelect.closest('[data-lp-hw-day]');
        this.setActiveDay(selectedDay && selectedDay.dataset.lpHwDay);
        return;
      }

      var add = event.target.closest('[data-lp-hw-product-add]');
      if (add && this.root.contains(add)) {
        event.preventDefault();
        var card = add.closest('[data-lp-hw-product]');
        var product = card && this.products.get(card.dataset.variantId || '');
        if (product) this.chooseProduct(product);
        return;
      }

      var pill = event.target.closest('[data-lp-hw-filter]');
      if (pill && this.root.contains(pill)) {
        event.preventDefault();
        this.applyFilter(pill.dataset.lpHwFilter || 'all');
        return;
      }

      if (event.target.closest('[data-lp-hw-prev]')) {
        event.preventDefault();
        this.moveCarousel(-1);
        return;
      }

      if (event.target.closest('[data-lp-hw-next]')) {
        event.preventDefault();
        this.moveCarousel(1);
        return;
      }

      if (event.target.closest('[data-lp-hw-submit]')) {
        event.preventDefault();
        this.submitPack();
      }
    }

    onBlockSelect(event) {
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) return;
      var matching = Array.from(this.root.querySelectorAll('[data-lp-hw-block-id]')).find(function (pill) {
        return pill.dataset.lpHwBlockId === blockId;
      });
      if (matching) this.applyFilter(matching.dataset.lpHwFilter || 'all');
    }

    onPointerDown(event) {
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!finePointer || event.button !== 0) return;
      if (event.target.closest('a, button, input, select, textarea')) return;

      this.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        scrollLeft: this.viewport.scrollLeft,
        moved: false
      };
      this.viewport.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.drag || this.drag.pointerId !== event.pointerId) return;
      var delta = event.clientX - this.drag.startX;
      if (Math.abs(delta) > 5) {
        this.drag.moved = true;
        this.viewport.classList.add('is-dragging');
      }
      if (!this.drag.moved) return;
      event.preventDefault();
      this.viewport.scrollLeft = this.drag.scrollLeft - delta;
    }

    onPointerUp(event) {
      if (!this.drag || this.drag.pointerId !== event.pointerId) return;
      this.justDragged = this.drag.moved;
      this.viewport.classList.remove('is-dragging');
      if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      this.drag = null;
      if (this.justDragged) window.setTimeout(() => { this.justDragged = false; }, 0);
    }

    setActiveDay(key) {
      if (!dayOrder.includes(key)) return;
      this.activeDay = key;
      this.saveSelection();
      this.render();
    }

    removeDay(key) {
      if (!dayOrder.includes(key)) return;
      this.selected.set(key, null);
      this.activeDay = key;
      this.saveSelection();
      this.render();
      this.announce(dayNames[key] + ' quedó libre. ' + (this.root.dataset.emptyCopy || 'Elige un snack.'));
    }

    chooseProduct(product) {
      if (!product.available) return;
      var target = this.activeDay;

      if (this.selected.get(target)) {
        var firstEmpty = dayOrder.find((key) => !this.selected.get(key));
        if (firstEmpty) target = firstEmpty;
      }

      this.selected.set(target, product);
      var nextEmpty = dayOrder.find((key) => !this.selected.get(key));
      this.activeDay = nextEmpty || target;
      this.saveSelection();
      this.render();
      this.announce(product.title + ' agregado a ' + dayNames[target].toLowerCase() + '.');
    }

    applyFilter(handle) {
      this.activeFilter = handle || 'all';
      var self = this;

      this.products.forEach(function (product) {
        var visible = self.activeFilter === 'all' || product.collections.has(self.activeFilter);
        product.element.hidden = !visible;
        product.element.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });

      this.root.querySelectorAll('[data-lp-hw-filter]').forEach(function (pill) {
        var active = pill.dataset.lpHwFilter === self.activeFilter;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.viewport.scrollLeft = 0;
      this.scheduleLayout();
    }

    render() {
      var self = this;
      dayOrder.forEach(function (key) { self.renderDay(key); });
      this.renderProductStates();
      this.renderCta();
    }

    renderDay(key) {
      var day = this.days.get(key);
      if (!day) return;
      var product = this.selected.get(key);
      var active = key === this.activeDay;

      day.element.classList.toggle('is-active', active);
      day.element.classList.toggle('is-empty', !product);
      day.element.dataset.variantId = product ? product.variantId : '';
      day.element.dataset.productId = product ? product.productId : '';
      day.element.dataset.available = product && product.available ? 'true' : 'false';
      if (day.select) {
        day.select.setAttribute('aria-pressed', active ? 'true' : 'false');
        day.select.setAttribute('aria-label', (product ? 'Reemplazar' : 'Seleccionar') + ' ' + dayNames[key].toLowerCase());
      }

      if (day.media) {
        day.media.replaceChildren();
        if (product && product.image) {
          var image = document.createElement('img');
          image.className = 'lp-hw__day-image';
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'eager';
          day.media.appendChild(image);
        } else {
          var emptyIcon = document.createElement('span');
          emptyIcon.className = 'lp-hw__day-empty-icon';
          emptyIcon.setAttribute('aria-hidden', 'true');
          emptyIcon.textContent = '+';
          day.media.appendChild(emptyIcon);
        }
      }

      if (day.title) day.title.textContent = product ? product.title : 'Elige un snack';
      if (day.remove) day.remove.classList.toggle('is-hidden', !product);
    }

    renderProductStates() {
      var counts = new Map();
      this.selected.forEach(function (product) {
        if (!product) return;
        counts.set(product.variantId, (counts.get(product.variantId) || 0) + 1);
      });

      this.products.forEach(function (product) {
        var count = counts.get(product.variantId) || 0;
        product.element.classList.toggle('is-selected', count > 0);
        var button = product.element.querySelector('[data-lp-hw-product-add]');
        if (!button) return;
        button.setAttribute(
          'aria-label',
          count > 0
            ? product.title + ' seleccionado ' + count + (count === 1 ? ' vez. Elegir de nuevo' : ' veces. Elegir de nuevo')
            : 'Agregar ' + product.title + ' al espacio activo'
        );
      });
    }

    commercialGateOpen() {
      var status = this.root.dataset.commercialStatus;
      var activeStatus = status === 'active' || status === 'configured_and_active';
      return activeStatus &&
        isTrue(this.root.dataset.allowCart) &&
        !isTrue(this.root.dataset.previewMode) &&
        Boolean(this.appstleBundleReference);
    }

    isComplete() {
      return dayOrder.every((key) => {
        var product = this.selected.get(key);
        return Boolean(product && product.available && product.variantId);
      });
    }

    renderCta() {
      var complete = this.isComplete();
      var selectedCount = Array.from(this.selected.values()).filter(Boolean).length;
      var enabled = complete && this.commercialGateOpen() && !this.addingToCart;
      this.root.classList.toggle('is-pack-complete', complete);
      this.root.dataset.packComplete = complete ? 'true' : 'false';
      this.submitButton.disabled = !enabled;
      this.submitButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      this.submitButton.classList.toggle('is-loading', this.addingToCart);
      this.selectionCountElements.forEach(function (element) {
        element.textContent = complete
          ? '5 productos seleccionados'
          : selectedCount + ' de 5 productos seleccionados';
      });
    }

    visibleProducts() {
      return Array.from(this.products.values()).filter(function (product) {
        return !product.element.hidden;
      });
    }

    scheduleLayout() {
      window.cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = window.requestAnimationFrame(this.layout.bind(this));
    }

    layout() {
      var visible = this.visibleProducts();
      var rows = this.mobileQuery.matches ? 2 : 3;
      var groupSize = rows * 3;
      var groups = Math.max(1, Math.ceil(visible.length / groupSize));
      var columns = groups * 3;
      var trackStyle = window.getComputedStyle(this.track);
      var viewportStyle = window.getComputedStyle(this.viewport);
      var gap = Number.parseFloat(trackStyle.columnGap) || 0;
      var padding = (Number.parseFloat(viewportStyle.paddingLeft) || 0) + (Number.parseFloat(viewportStyle.paddingRight) || 0);
      var usableWidth = Math.max(0, this.viewport.clientWidth - padding);
      var cardWidth = Math.max(82, Math.floor((usableWidth - gap * 2) / 3));

      this.root.style.setProperty('--lp-hw-card-width', cardWidth + 'px');
      this.track.style.gridTemplateColumns = 'repeat(' + columns + ', var(--lp-hw-card-width))';

      this.products.forEach(function (product) {
        product.element.style.removeProperty('grid-row');
        product.element.style.removeProperty('grid-column');
      });

      visible.forEach(function (product, index) {
        var group = Math.floor(index / groupSize);
        var local = index % groupSize;
        var row = Math.floor(local / 3) + 1;
        var column = group * 3 + (local % 3) + 1;
        product.element.style.gridRow = String(row);
        product.element.style.gridColumn = String(column);
      });

      if (this.emptyCatalog) this.emptyCatalog.hidden = visible.length > 0;
      this.viewport.scrollLeft = Math.min(this.viewport.scrollLeft, Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth));
      this.updateCarousel();
    }

    moveCarousel(direction) {
      var distance = this.viewport.clientWidth * 0.85 * direction;
      this.viewport.scrollBy({
        left: distance,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    scheduleCarouselUpdate() {
      window.cancelAnimationFrame(this.carouselFrame);
      this.carouselFrame = window.requestAnimationFrame(this.updateCarousel.bind(this));
    }

    updateCarousel() {
      var max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      var position = Math.max(0, Math.min(max, this.viewport.scrollLeft));
      var coverage = this.viewport.scrollWidth > 0
        ? Math.min(1, (position + this.viewport.clientWidth) / this.viewport.scrollWidth)
        : 1;
      var percent = Math.round(coverage * 100);

      if (this.progressBar) this.progressBar.style.transform = 'scaleX(' + coverage + ')';
      if (this.progress) this.progress.setAttribute('aria-valuenow', String(percent));
      if (this.previousButton) this.previousButton.disabled = max < 2 || position <= 2;
      if (this.nextButton) this.nextButton.disabled = max < 2 || position >= max - 2;
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      window.requestAnimationFrame(() => { this.status.textContent = message; });
    }

    showCartMessage(message, state) {
      if (!this.cartMessage) return;
      this.cartMessage.textContent = message || '';
      this.cartMessage.hidden = !message;
      if (state) this.cartMessage.dataset.state = state;
      else this.cartMessage.removeAttribute('data-state');
    }

    selectedItems(packId) {
      return dayOrder.map((key) => {
        var product = this.selected.get(key);
        return {
          id: safeInteger(product.variantId),
          quantity: 1,
          properties: {
            'Snack del pack': dayNames[key],
            '_appstle-bb-id': this.appstleBundleReference,
            '__appstle-bb-name': this.appstleBundleName,
            '_appstle-bundles-variants': safeInteger(product.variantId),
            '_appstle_bundles_subscription_selling_plan_id': null,
            '_appstle_bundles_type': this.appstleBundleType,
            '_appstle_bundle_mandatory_products': null,
            _lp_hw_campaign: this.campaignId,
            _lp_hw_pack_id: packId,
            _lp_hw_day: key,
            _lp_hw_version: '2'
          }
        };
      });
    }

    async fetchJson(url, options) {
      var response = await fetch(url, options);
      var payload;
      try {
        payload = await response.json();
      } catch (error) {
        payload = {};
      }
      if (!response.ok) {
        var message = payload.description || payload.message || 'Shopify rechazó la solicitud.';
        throw new Error(message);
      }
      return payload;
    }

    async getCart(signal) {
      return this.fetchJson(appendJs(cartRoute('base')), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: signal
      });
    }

    packLines(cart, packId) {
      return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
        var properties = item.properties || {};
        return properties._lp_hw_pack_id === packId;
      });
    }

    verifyPack(cart, packId) {
      var lines = this.packLines(cart, packId);
      if (lines.length !== dayOrder.length) return false;
      var seen = new Set();
      var valid = lines.every(function (line) {
        var properties = line.properties || {};
        var day = properties._lp_hw_day;
        if (!dayOrder.includes(day) || seen.has(day) || line.quantity !== 1) return false;
        if (properties['_appstle-bb-id'] !== this.appstleBundleReference) return false;
        if (properties._appstle_bundles_type !== this.appstleBundleType) return false;
        seen.add(day);
        return true;
      }, this);
      return valid && seen.size === dayOrder.length;
    }

    async cleanupPack(cart, packId, signal) {
      var lines = this.packLines(cart, packId);
      if (!lines.length) return true;
      var updates = {};
      lines.forEach(function (line) { updates[line.key] = 0; });
      await this.fetchJson(appendJs(cartRoute('update')), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates }),
        signal: signal
      });
      return true;
    }

    async submitPack() {
      if (this.addingToCart || !this.isComplete() || !this.commercialGateOpen()) return;

      var packId = uniquePackId();
      var signalController = new AbortController();
      var timeout = window.setTimeout(function () { signalController.abort(); }, 20000);
      this.cartController = signalController;
      this.addingToCart = true;
      this.showCartMessage('', '');
      this.renderCta();
      this.announce('Agregando tu canasta al carrito.');

      try {
        await this.fetchJson(appendJs(cartRoute('add')), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: this.selectedItems(packId) }),
          signal: signalController.signal
        });

        var cart = await this.getCart(signalController.signal);
        if (!this.verifyPack(cart, packId)) {
          await this.cleanupPack(cart, packId, signalController.signal);
          throw new Error('El pack no llegó completo al carrito.');
        }

        if (window.theme) window.theme.cartData = cart;
        publicCartEvent('cart:updated', { cart: cart });
        publicCartEvent('lp-hw:pack-added', { cart: cart, packId: packId, campaignId: this.campaignId });

        this.showCartMessage('Tu canasta de cinco snacks fue agregada al carrito.', 'success');
        this.announce('Canasta agregada al carrito.');
        var drawerOpened = await refreshCornerstoneChrome();
        if (!drawerOpened) window.location.assign(cartRoute('base'));
      } catch (error) {
        var cleanupFailed = false;
        var recoveryController = new AbortController();
        var recoveryTimeout = window.setTimeout(function () { recoveryController.abort(); }, 10000);
        try {
          var currentCart = await this.getCart(recoveryController.signal);
          if (this.packLines(currentCart, packId).length) {
            await this.cleanupPack(currentCart, packId, recoveryController.signal);
          }
        } catch (cleanupError) {
          cleanupFailed = true;
        } finally {
          window.clearTimeout(recoveryTimeout);
        }

        var errorCopy = this.root.dataset.errorCopy || 'No pudimos añadir el pack. Revisa tus snacks e inténtalo de nuevo.';
        if (cleanupFailed) errorCopy += ' Revisa el carrito antes de volver a intentarlo.';
        this.showCartMessage(errorCopy, 'error');
        this.announce(errorCopy);
      } finally {
        window.clearTimeout(timeout);
        this.cartController = null;
        this.addingToCart = false;
        this.renderCta();
      }
    }

    destroy() {
      this.abortController.abort();
      if (this.cartController) this.cartController.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.cancelAnimationFrame(this.layoutFrame);
      window.cancelAnimationFrame(this.carouselFrame);
      instances.delete(this.root);
    }
  }

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    var instance = new HalloweenPack(root);
    instances.set(root, instance);
    instance.init();
  }

  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-lp-hw-root]')) initRoot(scope);
    scope.querySelectorAll('[data-lp-hw-root]').forEach(initRoot);
  }

  function unload(scope) {
    if (!scope) return;
    var roots = [];
    if (scope.matches && scope.matches('[data-lp-hw-root]')) roots.push(scope);
    scope.querySelectorAll('[data-lp-hw-root]').forEach(function (root) { roots.push(root); });
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  var runtime = { scan: scan, unload: unload };
  window[runtimeKey] = runtime;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
